(function() {
    'use strict';

    var lang = $('html').attr('lang');
    var translation = {
      'en': {
        'error.default': 'Oops, something went wrong',
        'error.404': 'Invalid ID',
      },
      'zh-TW': {
        'error.default': '發生未知錯誤',
        'error.404': '錯誤的序號',
      },
    };

    function t(key) {
      return translation[lang][key];
    }

    function resolveIdFromURLSearchParams() {
        var params = new URLSearchParams(document.location.search);
        return params.get('id');
    }

    function fetchQRCode(id) {
        return $.ajax({
            url: '/tools/promoproxy/api/public/qrcode',
            type: 'GET',
            dataType: 'json',
            contentType: 'application/json',
            data: {
                id: id,
            },
        }).done(function(data) {
            $('#qrcode-wrapper').html('<img style="width: 100%; max-width: 196px;" src="' + data.qrcode + '" alt="QR Code" />');
            $('#passcode-wrapper').html('<h1>' + data.coupon_code + '</h1>');
        }).fail(function(xhr) {
            var message = t('error.default');
            if (xhr.status === 404) {
                message = t('error.404');
            }
            $('#qrcode-wrapper').html('<h1>' + message + '</h1>');
        });
    }

    function init() {
        var id = resolveIdFromURLSearchParams();
        if (id) {
            fetchQRCode(id);
        } else {
            window.location.replace('/');
        }
    }

    init();
    return {};
})();
